<template>
  <div id="app">
    <template v-if="!isMobile">
      <!-- <StarCloud></StarCloud> -->
      <LoginStar></LoginStar>
      <HomePage :isMobile="false"></HomePage>
    </template>
    <template v-else>
      <!-- <StarCloud></StarCloud>
      <HomePage></HomePage> -->
      <iframe
        src="/mHome/mHome.html"
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        "
        frameborder="0"
      ></iframe>
      <HomePage :isMobile="true"></HomePage>
    </template>
    <!-- <SvgNav></SvgNav> -->
  </div>
</template>

<script>
import LoginStar from "./components/LoginStar.vue";
import StarCloud from "./components/StarCloud.vue";
import SvgNav from "./components/SvgNav";
import HomePage from "./components/HomePage";

export default {
  name: "App",
  components: {
    LoginStar,
    StarCloud,
    SvgNav,
    HomePage,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    //判断手机端还是电脑端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    this.isMobile = this._isMobile();
    if (this.isMobile) {
      console.log("手机端");
    } else {
      console.log("PC端");
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
}
body {
  display: flex;
}
#app {
  width: 100%;
  height: 100%;
  position: relative;
}
/* 书法 */
@font-face {
  font-family: "iconfont";
  src: url("https://gz-lbt-bucket.oss-cn-guangzhou.aliyuncs.com/images/2022/11/121668258878000")
    format("truetype");
}
/* 肥肥` */
@font-face {
  font-family: "iconfont2";
  src: url("https://gz-lbt-bucket.oss-cn-guangzhou.aliyuncs.com/images/2022/11/121668258810000")
    format("truetype");
}
.font {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.font2 {
  font-family: "iconfont2" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 旋转动画 */
.circular {
  animation: rotate 5s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
</style>
